const KeenSlider = window.KeenSlider

const { breakpoints } = window.BAO.MediaBreakpoints
const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class HeaderSearchDropdown extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.activeRequestController = null
    this.lastQuery = ''
  }

  connectedCallback () {
    super.connectedCallback()

    this.initialViewCarousel = this.setInitialViewCarousel()

    this.handleResize()
  }

  setupListeners () {
    super.setupListeners()

    // Resize events
    this.handleResize = this.handleResize.bind(this)

    this.debouncedResize = window.BAO.Utils.debounce((event) => {
      this.handleResize(event)
    }, 300)

    this.listeners.add(window, 'resize', this.debouncedResize)

    // Input and form events
    this.debouncedHandleInput = window.BAO.Utils.debounce((event) => {
      this.handleInput(event)
    }, 300)

    this.listeners.add(
      this.els.input.element,
      'input',
      this.debouncedHandleInput,
    )

    this.listeners.add(
      this.els.form.element,
      'submit',
      this.handleSubmit.bind(this),
    )

    this.listeners.add(
      this.externalEls.input.element,
      'input',
      this.debouncedHandleInput,
    )

    this.listeners.add(
      this.externalEls.form.element,
      'submit',
      this.handleSubmit.bind(this),
    )
  }

  setInitialViewCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.7,
          spacing: 1,
        },
        breakpoints: {
          [`(min-width: ${breakpoints.sm}px)`]: {
            slides: {
              perView: 2.2,
              spacing: 1,
            },
          },
          [`(min-width: ${breakpoints.lg}px)`]: {
            disabled: true,
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }

  handleResize () {
    if (window.BAO.MediaBreakpoints.isLg) {
      this.externalEls.dialog.element.setAttribute('popover', 'auto')
      return
    }

    this.externalEls.dialog.element.removeAttribute('popover')
  }

  handleInput (event) {
    const rawValue = event.target.value
    const searchTerm = rawValue.trim()

    if (this.els.input.element.value !== rawValue) {
      this.els.input.element.value = rawValue
    }
    if (this.externalEls.input.element.value !== rawValue) {
      this.externalEls.input.element.value = rawValue
    }

    if (!searchTerm.length) {
      this.cancelPendingRequest()
      this.setView('initial')
      return
    }

    this.getSearchResults(searchTerm)
  }

  cancelPendingRequest () {
    if (this.activeRequestController) {
      this.activeRequestController.abort()
      this.activeRequestController = null
    }
  }

  getSearchResults (searchTerm) {
    this.cancelPendingRequest()

    const controller = new AbortController()
    this.activeRequestController = controller
    this.lastQuery = searchTerm

    fetch(
      `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(searchTerm)}&resources[limit]=4&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,body&section_id=predictive-search`,
      { signal: controller.signal },
    )
      .then((response) => response.text())
      .then((text) => {
        if (controller.signal.aborted) return

        const html = document.createElement('div')
        html.innerHTML = text

        const resultsSource = html.querySelector(
          '[data-header-search-dropdown-el="resultsView"]',
        )

        if (!resultsSource) {
          this.renderNoResults(searchTerm)
          this.setView('no-results')
          return
        }

        const productCount = resultsSource.querySelectorAll(
          '[data-header-search-dropdown-el="resultsProductsTemplate"] > li',
        ).length

        const keywordCount = resultsSource.querySelectorAll(
          '[data-header-search-dropdown-el="resultsKeywordsTemplate"] > li',
        ).length

        const categoryCount = resultsSource.querySelectorAll(
          '[data-header-search-dropdown-el="resultsCategoriesTemplate"] > li',
        ).length

        if (!productCount && !keywordCount && !categoryCount) {
          this.renderNoResults(searchTerm)
          this.setView('no-results')
          return
        }

        this.els.resultsView.element.innerHTML = resultsSource.innerHTML
        this.renderResultsTitle(productCount)
        this.setView('results')
      })
      .catch((error) => {
        if (error.name === 'AbortError') return
        console.error(error)
      })
      .finally(() => {
        if (this.activeRequestController === controller) {
          this.activeRequestController = null
        }
      })
  }

  renderResultsTitle (count) {
    const titleEl = this.els.resultsProductsTitle.element
    if (!titleEl?.dataset.format) return

    titleEl.textContent = titleEl.dataset.format.replaceAll('[count]', count)
  }

  renderNoResults (query) {
    const titleEl = this.els.noResultsTitle.element
    if (!titleEl?.dataset.format) return

    titleEl.innerHTML = titleEl.dataset.format.replaceAll('[query]', query)
  }

  setView (view) {
    const views = {
      initial: this.els.initialView.element,
      results: this.els.resultsView.element,
      'no-results': this.els.noResultsView.element,
      redirect: this.els.redirectView.element,
    }

    Object.entries(views).forEach(([name, element]) => {
      if (name === view) {
        element.removeAttribute('hidden')
      } else {
        element.setAttribute('hidden', '')
      }
    })
  }

  handleSubmit (event) {
    const input = event.target.querySelector('input[type="search"]')
    const query = input?.value.trim()

    if (!query) {
      event.preventDefault()
    }
  }

  handleDrawerChange () {
    if (window.drawers.activeDrawerKey === 'search') {
      setTimeout(() => {
        if (window.BAO.MediaBreakpoints.isLg) {
          this.externalEls.input.element.focus()
        } else {
          this.els.input.element.focus()
        }
      }, 300)

      return
    }

    this.cancelPendingRequest()

    setTimeout(() => {
      this.els.input.element.value = ''
      this.externalEls.input.element.value = ''
      this.setView('initial')
    }, 300)
  }
}

if (!customElements.get('header-search-dropdown')) {
  customElements.define('header-search-dropdown', HeaderSearchDropdown)
}
